import { LitElement, html, css } from 'lit';
import './DashboardHeader.js';
import './DashboardGraph.js';
import './DashboardMainContent.js';

class DashboardContainer extends LitElement {
  static styles = css`
    :host {

    }
  `;

  render() {
    return html`
      <dashboard-header></dashboard-header>
      <dashboard-main-content></dashboard-main-content>
    `;
  }
}

customElements.define('dashboard-container', DashboardContainer);
